import { useState } from "react"

function useMenu() {
    const [showMenu, setShowMenu] = useState(false)

    const OpenMenu = (e) => {
        setShowMenu(true)
    }

    const CloseMenu = (e) => {
        showMenu && setShowMenu(false)
    }

  return {
      showMenu,
      setShowMenu,
      OpenMenu,
      CloseMenu
  }
}

export default useMenu